<template>
  <div class="auth">
    <div class="auth__content" ref="modalRef">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import {useAppStore} from "@/stores/app.js";
import {ref} from "vue";
import {onClickOutside} from "@vueuse/core";

const appStore = useAppStore()

const closeModal = () => {
  appStore.setActiveState(null)
}

const modalRef = ref(null)
onClickOutside(modalRef, () => closeModal())
</script>

<style lang="scss" scoped>
.auth {
  position: fixed;
  z-index: 2;
  width: 100vw;
  height: 100vh;
  top: 92px;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.5);

  &__content {
    position: absolute;
    z-index: 2;
    top: 50px;
    background-color: $white;
    border-radius: 43px;
    width: 393px;
    padding: 25px 35px;
  }
}

@media (max-width: 450px) {
  .auth {
    &__content {
      width: 300px;
      border-radius: 25px;
    }
  }
}
</style>